import hometreeLogoAsset from "@/assets/financing/hometree/Powered_by_Hometree_Finance_Logo_-_mono_white.svg.asset.json";
import { cn } from "@/lib/utils";

const logoSrc = hometreeLogoAsset.url;

const LOGO_ALT = "Powered by Hometree Finance";

type HometreePartnerBannerProps = {
  className?: string;
};

/**
 * Navy partner banner for the Solar Lease Plan page, mirroring the
 * Ideal4Finance partner banner on the Loan Finance page. The white mono
 * Hometree Finance lockup is centred on the navy background; the logo already
 * reads "Powered by Hometree Finance" so no surrounding sentence copy is added.
 */
export function HometreePartnerBanner({ className }: HometreePartnerBannerProps) {
  return (
    <div
      className={cn(
        "w-full rounded-xl bg-primary px-6 py-8 md:px-10 md:py-10 flex items-center justify-center",
        className,
      )}
    >
      <img
        src={logoSrc}
        alt={LOGO_ALT}
        className="h-14 md:h-16 w-auto"
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}
